import { render, staticRenderFns } from "./Excess.vue?vue&type=template&id=d5d6e490&"
import script from "./Excess.vue?vue&type=script&lang=js&"
export * from "./Excess.vue?vue&type=script&lang=js&"
import style0 from "./Excess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Excess.vue"
export default component.exports